import { MonitoringProtocolPage } from '@features/monitoringOffer';

export const MonitoringProtocol = () => {
	return (
		<div className="w-full h-full max-w-[1440px] mx-auto px-5">
			<MonitoringProtocolPage />
		</div>
	);
};
